import { useParams } from 'react-router-dom';
import DownloadApp from '../../components/DownloadApp';
import './EventAlbum.css';

export default function EventAlbum() {
  const { event_code } = useParams();

  return (
    <main className="event-album-page">
      <div className="event-album-container">
        <section className="event-album-card" aria-labelledby="event-album-title">
          <span className="event-album-icon" aria-hidden="true">▧</span>
          <p className="event-album-eyebrow">YOUR EVENT ALBUM</p>
          <h1 id="event-album-title">Your memories are waiting</h1>
          <p>Open this album in the Click app to view your event photos.</p>
          <a className="event-album-open" href={`clickapp://events/album/${encodeURIComponent(event_code)}`}>Open in app</a>
          <p className="event-album-hint">Don’t have Click yet? Download the app below, then return here to open your album.</p>
        </section>
        <DownloadApp />
      </div>
    </main>
  );
}
